import AOS from 'aos';
import DraggableNav from './js/draggableNav';
import LoadVideos from './js/loadVideos';
import Analytics from './js/analytics';

export default class Collection {
  constructor() {
    this.example = 'example';
  }

  init() {
    this.example = 'initialized';
    this.initVidoes();
    this.initNav();
    this.initAnalytics();
    AOS.init();
  }

  initNav() {
    const d = new DraggableNav();
    d.init();
  }

  initVidoes() {
    const b = new LoadVideos();
    b.init();
  }

  initAnalytics() {
    this.utag = new Analytics();
    this.utag.fireViewTag('b150-collection');
  }
}



// WEBPACK FOOTER //
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_bcom/package/src/collection.js